'use strict';

export const uspInformation = {
  elemSelector: '.js-usp-elem',
  init() {
    $(document).on('click', this.elemSelector, e => {
      const $simpleTextPopin = $(e.currentTarget).closest(this.elemSelector).find('.simpleTextPopin');
      if ($simpleTextPopin.length) {
        simpleTextPopin.open($simpleTextPopin);
      }
    });
  }
};